import { REQUIRED_PROFILE_FIELDS_QUERY_PARAMETER } from '@src/onboarding/smart-connect/required-profile-fields';

export const WHITELABEL_PARAMETER = 'wl';
export const MOVE_REPUBLIC_GLOBAL_COMMUNITY_MEMBERSHIP_MODE_QUERY_PARAMETER =
    'mrgcm';

export type SmartConnectParams = Record<string, string[]>;

export interface SmartConnectParamsInput {
    tenantCodes: string[];
    communityCodes: string[];
    communityTeamRequiredCodes: string[];
    teamCodes: string[];
    challengeCodes: string[];
    tourGuideEnabled: boolean;
    requiredProfileFieldCodes: string[];
    moveRepublicGlobalCommunityMembershipMode: string;
}

export function buildSmartConnectParams(
    input: SmartConnectParamsInput
): SmartConnectParams {
    const params: SmartConnectParams = {};
    const add = (name: string, values: string[]) => {
        if (values.length) {
            params[name] = values;
        }
    };

    add('tenant', input.tenantCodes);
    add('community', input.communityCodes);
    add('ctr', input.communityTeamRequiredCodes);
    add('team', input.teamCodes);
    add('challenge', input.challengeCodes);
    add('tg', input.tourGuideEnabled ? ['true'] : []);
    add(
        REQUIRED_PROFILE_FIELDS_QUERY_PARAMETER,
        input.requiredProfileFieldCodes.length
            ? [input.requiredProfileFieldCodes.join('')]
            : []
    );
    add(MOVE_REPUBLIC_GLOBAL_COMMUNITY_MEMBERSHIP_MODE_QUERY_PARAMETER, [
        input.moveRepublicGlobalCommunityMembershipMode
    ]);

    return params;
}

export function withWhitelabel(
    params: SmartConnectParams,
    whitelabelId?: string
): SmartConnectParams {
    return whitelabelId
        ? { ...params, [WHITELABEL_PARAMETER]: [whitelabelId] }
        : params;
}

export function inlineJoinUrl(
    baseUrl: string,
    params: SmartConnectParams
): string {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([name, values]) =>
        values.forEach((value) => query.append(name, value))
    );
    const text = query.toString();
    return text ? `${baseUrl}/app/join?${text}` : `${baseUrl}/app/join`;
}

export function storedJoinUrl(baseUrl: string, key: string): string {
    return `${baseUrl}/app2/join?e=${encodeURIComponent(key)}`;
}
